import React from "react";
import {LinkContainer} from "react-router-bootstrap";
import {Button} from "react-bootstrap";
import {useTranslation} from "react-i18next";

import GenericContentPage from "../common/GenericContentPage";
import ContentTranslation from '../statichtml/ProviderAcceptanceTerms'
import i18n from '../i18n';

const ProviderAcceptanceTerms = () => {
    const {t} = useTranslation();

    return (
        <GenericContentPage headTitle={t("ProviderAcceptanceTerms.page-head-title")} title={t("ProviderAcceptanceTerms.provider-acceptance-terms")}>
            {(() => {
                if (ContentTranslation[i18n.language]) {
                    return <div dangerouslySetInnerHTML={{__html: ContentTranslation[i18n.language]}} />
                } else if (ContentTranslation['en']) {
                    return <div dangerouslySetInnerHTML={{__html: ContentTranslation['en']}} />
                }
            })()}
            <div
                style={{
                    marginTop: "4rem",
                    borderTop: "1px solid #eee",
                    padding: "2rem 0 0 0",
                }}
            >
                <p className="mb-0 mr-3">
                    <span className="mr-4">{t("ProviderAcceptanceTerms.explanation-link-provider-application")}</span>
                    <span>
                        <LinkContainer active={false} to="/provider-application">
                            <Button size="sm" variant="primary" active={false}>
                                {t("ProviderAcceptanceTerms.link-provider-application")}
                            </Button>
                        </LinkContainer>
                    </span>
                </p>
            </div>
        </GenericContentPage>
    );
};

export default ProviderAcceptanceTerms;
